import { modes } from '@/utils/types'
import style from './css'

const BamboraEcommerce = {
  label: 'Demo-eCommerce Simple',
  config: {
    userId: 'PayTestGB',
    merchantId: 198003,
    mode: modes.ECOMMERCE,
    amount: 25,
    scrollToOffset: 8,
    containerWidth: '500px',
    listRadio: true,
    logoFullWidth: true
  },
  theme: {
    buttons: {
      color: '#29b355'
    },
    labels: {
      color: '#1e1e1e',
      fontSize: '12px'
    },
    headings: {
      color: '#1e1e1e',
      fontSize: '14px'
    },
    loader: {
      color: '#29b355'
    },
    input: {
      color: '#1e1e1e',
      height: '52px'
    },
    headerbackground: {
      color: '#ffffff'
    },
    cardbackground: {
      color: '#ffffff'
    }
  },
  style
}

const bamboraEcommercePage = {
  ...BamboraEcommerce,
  label: 'Demo-eCommerce Simple Page',
  display: 'page',
  config: {
    ...BamboraEcommerce.config,
    logoUrl:
      'https://s3-eu-west-1.amazonaws.com/epayzero/company/1051137/paymentwindow/1.svg?636465219764774612'
  },
  style:
    style +
    `
  .list-payment-methods {
    padding: 0!important;
  }`
}

const bamboraGambling = {
  ...BamboraEcommerce,
  label: 'Demo-Gambling Simple',
  config: {
    merchantId: 198003,
    tabs: true
  },
  style:
    style +
    `
    #cashier input {
      border: 0!important;
      background: transparent!important;
    }
    `
}

const bamboraGamblingPage = {
  ...BamboraEcommerce,
  label: 'Demo-Gambling Simple Page',
  display: 'page',
  config: {
    ...BamboraEcommerce.config,
    logoUrl:
      'https://s3-eu-west-1.amazonaws.com/epayzero/company/1051137/paymentwindow/1.svg?636465219764774612'
  }
}

export default {
  BamboraEcommerce,
  bamboraEcommercePage,
  bamboraGambling,
  bamboraGamblingPage
}
